import React from 'react';
import { Button, Result } from 'antd';

const Http500 = () => (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: "100vh" }} >
        <Result
            status="500"
            title="500"
            subTitle="Ocorreu um erro inesperado."
            extra={<Button type="primary" onClick={() => window.location.reload()} >Recarregar a página</Button>}
        />
    </div>
);
export default Http500;